export default __webpack_public_path__ + "static/media/Venakis.c7978b56.jpg";